const StableValue = ({
  name,
  read,
  deps
}) => {
  let stableValue;
  let valueUpdated;
  const reset = () => {
    stableValue = void 0;
    valueUpdated?.();
  };
  return {
    name,
    readStable: () => stableValue ?? (stableValue = read()),
    subscribe: (onUpdate) => {
      valueUpdated = onUpdate;
      const unsubscribes = (deps ?? []).map((d) => d.subscribe(() => reset()));
      return () => unsubscribes.forEach((u) => u());
    },
    reset
  };
};
export {
  StableValue
};
//# sourceMappingURL=stable-value.js.map